// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"515753d1","952":"bfb24eec"}[chunkId] + ".chunk.js";
};